import sha1 from "js-sha1";
import parse from "url-parse";

export const hashPath = (url) => {
  const hash = sha1.create();
  const pathname = parse(url.toLowerCase()).pathname;

  hash.update(pathname);

  return hash.hex();
};
